import { render, staticRenderFns } from "./InformationAboutStatus.vue?vue&type=template&id=e886c1c0&"
import script from "./InformationAboutStatus.vue?vue&type=script&lang=js&"
export * from "./InformationAboutStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports